const translation = {
  // Navigation
  nav: {
    home: '首页',
    about: '关于我们',
    services: '服务项目',
    pricing: '收费标准',
    bookConsultation: '预约咨询',
    testimonials: '客户评价',
    faq: '常见问题',
    policyUpdates: '政策动态',
    // [T243] ground truth 的「资源」组第二行(见 en 镜像注)。此前缺席的唯一理由是
    // `/guides` 索引路由不存在,导航指向 404 比缺一行更糟;本卡建成该路由,故此行与
    // 路由同一个提交落地。
    guides: '指南',
    pathwayFinder: '找路径',
    // [T336] 资源组新行:实时 CRS 算分器(/crs-calculator)。
    crsCalculator: 'CRS 算分器',
    contact: '联系我们',
    // [T234] 见 en 镜像注:键名保留(t95 CHROME_KEYS 钉 `nav.more`,该锁在本卡写面外),
    // 值改为 ground truth 的「资源」组标签。
    more: '资源',
    methodology: '我们怎么做',
    login: '登录',
    // [T234] 服务下拉 = ground truth 六张服务专页;六个 slug 在
    // src/data/programsData.json 中都有真实 `/services/<slug>` 路由,零空头链接。
    servicesMenu: {
      expressEntry: 'EE 快速通道 — STEM 与 CEC',
      bcPnpTech: 'BC PNP Tech 科技人才省提名',
      spousalSponsorship: '配偶及家庭担保',
      c11Entrepreneur: 'C11 企业家工签',
      superVisa: '父母祖父母超级签证',
      pgwp: '学签与毕业工签 PGWP',
    },
  },

  // Header
  header: {
    bookConsultation: '预约咨询',
    openMenu: '打开主菜单',
  },

  // Shared micro-copy
  common: {
    close: '关闭',
  },

  // 404 (rendered outside LangLayout — language comes from the URL prefix)
  notFound: {
    title: '页面未找到',
    body: '您访问的页面不存在或已被移动。',
    home: '返回首页',
  },

  // Pathway Finder (interactive tool) Page
  pathwayFinder: {
    badge: '免费 · 约 8–10 分钟 · 无需注册',
    title: '免费加拿大移民评估',
    subtitle: '回答关于你的目标、学历、语言和工作的问题——我们给出适合的路径、指示性的快速通道分数,并把你接给持牌顾问。',
    intro:
      '这份较全面的自评对照 IRCC 实际打分的要素。它给你一个方向性参考——候选路径与指示性 CRS 估分——而非资格判定。大多数人 8–10 分钟完成;配偶与语言部分仅在与你相关时才出现。',
    start: '开始评估',
    disclaimer: '仅供一般参考——不构成法律意见,也不是对你资格的评估。使用本工具不形成顾问-客户关系。',
    progress: '第 {{n}} / {{total}} 步',
    choose: '请选择…',
    continue: '继续',
    back: '上一步',
    ability: { listening: '听', reading: '读', writing: '写', speaking: '说' },
    yourClb: '你的决定性水平:CLB {{clb}}',
    source: '来源',
    countryPlaceholder: '输入你的国家…',
    clbTitle: '什么是 CLB?(加拿大语言标准)',
    clbHelp: 'IRCC 把你各项考试分数换算成 CLB 等级(法语为 NCLC)。项目资格按你最低的一项计。下表:每个 CLB 各项所需最低分。',
    clbSource: 'IRCC 官方换算对照表',
    nocFind: '不确定?查找你的 NOC / TEER',
    nocTitle: '查找你的 NOC / TEER',
    nocIntro: '你职业的 TEER 等级决定快速通道资格——TEER 0–3 通常计入联邦技术工人与加拿大经验类。请选择与你主要职责相符的等级。',
    nocEligible: '计入快速通道',
    nocNotEligible: '一般不合资格',
    nocExamples: '示例',
    nocDisclaimer: '示例仅供参考——请按官方职责核对你的 NOC。具体认定请预约咨询。',
    nocOfficial: '打开官方 NOC 查找工具',
    resultsDisclaimer:
      '以下为一般性候选路径与指示性估算,仅基于你所填信息——不构成资格判定、法律意见或任何结果保证。具体是否可行,需经咨询确认。',
    resultsTitle: '值得探索的路径',
    officialSource: '官方来源',
    crsTitle: '指示性快速通道(CRS)估分',
    crsLabel: {
      competitive: '相对近期抽签有竞争力(分数线因抽签类型而异)。',
      borderline: '处于边缘——省提名或类别抽签可能是更好的路径。',
      improve: '低于近期普通分数线——省提名、更高语言/经验或类别抽签会有帮助。',
    },
    crsWithSpouse: '(已按含配偶计算)。',
    assumesECA: '假设你的境外学历已完成合格的学历认证(ECA)。',
    assumesLang: '假设你有合格的语言考试成绩。',
    crsDisclaimer:
      '仅为指示性估算,依据 IRCC 公开的 CRS 标准、按你所填信息计算。不保证你的实际分数或获得邀请(ITA)。你的官方分数仅在向 IRCC 提交快速通道档案后确定,且分数线每轮变动。',
    ctaTitle: '让持牌顾问给你个性化解读',
    ctaSubtitle:
      '把你的评估发给我们的持牌顾问 Yansi He(R708210),并预约 45 分钟咨询(99 加元,若签约可抵服务费),确认最适合你的路径。',
    bookCta: '预约咨询',
    nameLabel: '你的姓名',
    emailLabel: '你的邮箱',
    phoneLabel: '电话 / 微信(选填)',
    consent:
      '我同意 Think Forward Immigration 收集本评估中的信息,并通过邮件发送给其持牌移民顾问(RCIC),以便为咨询做准备并与我联系。我理解这仅为一般性、指示性的结果——并非移民建议或资格判定——且提交本评估不构成顾问-客户关系。我可发送邮件至 info@thinkforwardic.com 撤回同意或要求删除。',
    emailMe: '同时把结果副本发到我的邮箱。',
    leadSubmit: '发送我的评估',
    leadSuccess: '谢谢!你的评估正在发送给我们的顾问,我们会与你联系。请查收邮箱——也欢迎随时预约咨询。',
    leadError: '请填写姓名、邮箱并勾选同意框(或邮件 info@thinkforwardic.com)。',
    restart: '重新开始',
  },

  // Policy Updates (timeline) Page
  policyUpdates: {
    hero: {
      badge: '2026 年 6 月更新',
      title: '加拿大移民政策动态',
      subtitle:
        '我们追踪 IRCC 每一项重大变化——发生了什么、何时生效、对你意味着什么——并附上官方来源链接。政策不断变动,与时俱进是我们的本职。',
      lede:
        '2025–2026 年加拿大移民规则变动很快。我们追踪 IRCC 每一项重大变化——发生了什么、何时生效、意味着什么——每条都附官方政府来源链接。',
    },
    lastUpdated: '最近更新',
    faqHeading: '关于加拿大 2026 移民变化的常见问题',
    faq: {
      q1: '2026 年加拿大移民最大的变化有哪些?',
      a1: '2026 年的主要变化包括:永久居民目标下调、学签设上限(公立大学硕士与博士现已豁免 PAL)、快速通道类别抽签转向医疗/科研/交通职业、以及配偶开放工签与低薪 LMIA 规则收紧。上方每条变化都附官方 IRCC 来源链接。',
      q2: '配偶现在还能拿到加拿大开放工签吗?',
      a2: '自 2025 年 1 月 21 日起,配偶开放工签一般仅限 TEER 0/1 等较高技能职业(或特定优先行业)工人的配偶,且主申请人工签须剩余足够时长。多数学生及较低技能工人的配偶不再符合资格。',
      q3: '工作 offer 在快速通道里还加 CRS 分吗?',
      a3: '不加了。自 2025 年 3 月 25 日起,有效工作 offer(含 LMIA 支持的 offer)不再加 CRS 分(此前为 50 或 200 分)。工作 offer 仍可能影响某些项目的资格。',
      q4: '硕士和博士生现在还需要省级证明信(PAL)吗?',
      a4: '自 2026 年 1 月 1 日起,在公立指定院校就读硕士或博士项目的学生,申请学习许可时无需再提交省级证明信(PAL)。',
      q5: '留学生校外每周可以打工多少小时?',
      a5: '符合条件的学生在上课期间校外打工上限为每周 24 小时(2024 年底由 20 提升),假期可全职工作。',
    },
    filter: {
      all: '全部动态',
      current: '现行有效',
      past: '历史 / 已更新',
    },
    status: {
      current: '现行',
      superseded: '已被取代',
      historical: '历史',
    },
    criteria: '收录标准:2023 年以来对申请人有实质影响的加拿大移民重大变化——每条均链接到其官方 IRCC / 政府来源。',
    legend: {
      current: '该规则目前仍然适用',
      superseded: '已被下方更新的政策取代',
      historical: '一次性事件或已结束的旧通道——不再是现行规则',
    },
    label: {
      source: '官方来源',
      whatThisMeans: '这对你意味着 · 我们如何帮你',
    },
    share: {
      label: '分享',
      wechat: '微信',
      email: '邮件',
      copy: '复制链接',
      copied: '已复制链接',
      wechatHint: '链接已复制,粘贴到微信即可分享',
    },
    disclaimer:
      '信息截至 2026 年 6 月,仅供一般参考——移民规则经常变动。请务必在 IRCC 官方网站(canada.ca)核实,并就你的具体个案预约咨询。',
    cta: {
      title: '不确定最新规则如何影响你的个案?',
      subtitle:
        '预约 45 分钟咨询(99 加元,若签约可抵服务费),由持牌顾问 Yansi He(RCIC)为你清晰梳理当前可行方案。',
      button: '预约咨询',
    },
  },

  // Home Page
  // [T234] 标题与副题取 ground truth 中文首页
  // (docs/design/rebuild-v0b7764f/site/zh/index.html §HERO),owner 2026-07-29 裁定。
  // 「今天实现您的加拿大梦想」是全行业通用套话;这一对说的是真实问题(政策变动)、
  // 真实解法(免费 10 分钟评估)与真实背书(持牌 RCIC)。损失框架,零结果承诺
  // ——合规 linter 扫描本档(T216)。标点从 zip 与本档主流(全角)。
  'home.hero.title': '政策瞬息万变。10 分钟，看清你的位置。',
  'home.hero.subtitle': '免费 10 分钟评估，看清你的选项——由温哥华持牌 RCIC 设计并把关。',
  // 刻意不动:hero 按钮渲染 `pathwayFinder.start`,而 t95 锁要求本键的值出现在页面上
  // ——它经由 `home.cta.button` 出现。改指向或改措辞属另案,见 T234 §執行器裁決記 ①。
  'home.hero.cta': '开始免费评估',

  // T95 credibility strip (hero): factual license/verification/language facts only
  'home.credibility.rcic': 'Yansi He,持牌移民顾问 RCIC R708210',
  'home.credibility.cicc': '可在 CICC 官方注册名录查证',
  'home.credibility.bilingual': '中英双语服务',

  // [T234] 信任条 — T216/T223 因查无出处而拒写的两条事实(log 547)现有出处:
  // CICC 官方注册处,逐字段抄录在 docs/research/register-facts-2026-07-29.md。
  // 措辞上限由该档设定,禁扩写:注册处公布的是「某日的处分记录」,
  // 故「零纪律处分记录」可说,任何「保证无污点」式引申不可。
  'home.trust.licensedSince': '2021 年起持牌 RCIC',
  'home.trust.noDiscipline': '零纪律处分记录',
  // B2 已批承诺 — [T275 · Q5] 按 owner 裁决重锚到委托协议(§5-R Q5:报价在合同里,
  // 不存在单独的报价文件)。短位按位缩:时点不变量(任何后续付款之前)由整句位
  // (/pricing COMMITMENTS[1] 与 /testimonials 证据格正文)承载。
  'home.trust.fixedFee': '费用白纸黑字写入您签署的委托协议',

  // [T234] 政策条引导词,照 ground truth 的 `policy-label`。
  'home.policyWatch.label': 'IRCC 政策观察：',

  // ── [T244] WHY US 文案换装 —— 逐字取自基准站 zh/index.html §为什么选择我们 ──
  //
  // T240 只换了形(四条发丝栏、无卡片阴影),并在自己卡头如实写明「零文案改动」。
  // 本卡是文案那一半:四句口号 → 四条可核查的陈述(同一位顾问全程 · 付款前书面报价 ·
  // 注册表可查的持牌与零处分 · 案子不值得递交时我们直说)。
  // 逐字转写非创作:`homeFace.test.tsx` §k 每次运行重读基准站做**文本节点精确成员**比对。
  //
  // `stress` → `honest` 是**键退役**(非就地改名):基准站第四条是「诚实把关」,
  // 一个名叫 stress 的键装着它,只会让下一个人去找早已不存在的「无压力指导」
  // (T240 先例:退役键留在文件里 = 一次 merge 冲突就回滚);`pilot.test.tsx` 断言两语皆已删除。
  //
  // ⛔ 第四条第二句 —— 记档的刻意偏离。基准站原句「没有任何顾问可以合法保证获批。」
  // 命中合规 linter 的 `zh-baozheng-outcome`(保证获批),而 pattern 没有否定语义感知
  // (CV-35 为路径工具的免责句记的正是这个盲点;en 侧 `en-guarantee-outcome` 同形命中)。
  // CV-35 的修法是**豁免条目**,本卡走不了那条路(`src/i18n/lint-allowlist.json` 与
  // `COMPLIANCE-VERIFY.md` 都在写面外,而无核查行的豁免正是本仓禁止的蒙眼)。
  // ⇒ 该句**从裁定方那一侧复述**,且用的是本站已发布的同责措辞
  // (`src/pages/services/copy.ts` §disclaimer,T236)——同一份责任、零 linter 豁免、一个声音。
  //
  // [T275 · Q5+Q7] 另两条**裁决性偏离**(owner,承诺账本 §5-R,2026-08-02),
  // homeFace §k 以 DIVERGENCE 3 逐字钉住而非留在 verbatim 集:client.desc 不再锁
  // 人数(「同一位」会随业务增长自动变假——Q7 裁「不锁死人数」),transparent.desc
  // 的报价承诺重锚到签署的委托协议(Q5 裁「报价在合同里」——单独的书面报价文件并不存在)。
  // 基准站 zip 保留旧句;此两格以裁决为准,不再与 zip 对表。
  //
  // [T280 · Q6-A] 第四格(诚实把关)首句现在也是**裁决句**(owner,§5-R 增裁,
  // 2026-08-02):损失框架的转写句(「如果你的案子不值得递交……」)升级为 owner 选定的
  // 心理学 A 形——同一份拒绝生意的责任,外加建设性的后半句(「并告诉你,差的是什么」)。
  // zip 保留旧格;homeFace §k DIVERGENCE 1 重录为裁决对的逐字钉(+未动的复述第二句),
  // 并断言 zip 旧形不得回流。
  'home.why.eyebrow': '为什么选择我们',
  'home.why.title': '一位你可以当场验证的持牌专业人士——而不是销售话术',
  'home.why.client.title': '以客户为中心',
  'home.why.client.desc': '持牌顾问对您的案件全程亲自负责——从第一通电话到最终递交，中文或英文沟通。您的目标和时间线，是制定策略的出发点。',
  'home.why.transparent.title': '沟通透明',
  'home.why.transparent.desc': '全案费用以书面形式写入您签署的委托协议——任何后续付款之前，绝无隐藏费用。每一步花多少钱、下一步做什么，您始终心里有数。',
  'home.why.rcic.title': 'RCIC 持牌专业',
  // 两条注册表事实,措辞上限与 `home.trust.*` 同源:
  // docs/research/register-facts-2026-07-29.md 逐字段转写了持牌起始日(2021-11-03)
  // 与四张空白纪律表。放宽措辞 = homeFace §k 对该档比对即红,与 (b) 同律。
  'home.why.rcic.desc': '2021 年起持牌 · 零纪律处分记录——可随时在 CICC 官方注册表上验证。',
  'home.why.honest.title': '诚实把关',
  'home.why.honest.desc': '如果时机还不成熟，我们会在你花一分钱之前直说——并告诉你，差的是什么。申请是否成功由 IRCC 单方决定，任何持牌顾问都不得声称并非如此。',

  // ── [T244] 移民路径评估工具推广区 —— 基准站自己的第三区,我方此前整区缺失 ──
  //
  // 这一整区不在站上,也不在任何卡上,直到完成度审计改用**区块**而非页面做分母
  // (T242 run 1 → `docs/design/zip-parity-map.md` §5 新发现 ①)。首页在 hero 按钮里
  // 吆喝「免费评估」,却从没说清那是什么:三步、十分钟、答案只留在读者自己的浏览器里。
  // 这正是回应顾虑的文案,而它一直躺在基准站里。
  //
  // 逐字取自 `site/zh/index.html` §移民路径评估工具推广区,含 `home.threeStep.note`
  // (即 hero 的 `btn-note` 惯用法的**完整形**)。hero 那条较短的注(`pathwayFinder.badge`)
  // 不动——hero 在本卡写面外——所以两者是子集与超集的关系,只有这一条带「答案留在浏览器」。
  'home.threeStep.eyebrow': '免费工具',
  'home.threeStep.title': '三步找到你的移民路径',
  'home.threeStep.lead': '回答关于你的目标、学历、语言和工作经验的问题——获得适合你的移民路径、指示性 CRS 估分，以及清晰的下一步。',
  'home.threeStep.step1.title': '回答问题',
  'home.threeStep.step1.desc': '关于你的目标、学历、语言和工作经验——约 10 分钟，全部在你的浏览器中完成。',
  'home.threeStep.step2.title': '查看你的路径',
  'home.threeStep.step2.desc': 'Express Entry、BC PNP Tech、留学转移民、家庭担保——附指示性 CRS 估分。',
  'home.threeStep.step3.title': '与 RCIC 顾问确认',
  'home.threeStep.step3.desc': '在花钱买申请材料之前，先与持牌顾问确认你的路径是否走得通。',
  'home.threeStep.cta': '开始免费评估',
  'home.threeStep.note': '免费 · 约 8–10 分钟 · 无需注册 · 你的答案只保存在你的浏览器中',

  'home.consultant.title': '您的移民顾问',
  'home.consultant.name': 'Yansi He',
  'home.consultant.license': '创始人兼首席顾问，持牌移民顾问 RCIC R708210',
  'home.consultant.location': '位于大温哥华(本拿比)',
  'home.consultant.intro': '作为 Think Forward Immigration Consulting 的创始人兼首席顾问，Yansi He 在帮助科技专业人士及其家庭实现加拿大移民目标方面拥有丰富经验。',
  // ── [T262] 顾问区四条清单 —— 这里只放**框**,事实是读来的 ────────────────
  //
  // run2 §5b 判本块 ⚠ 的两条依据就是这四个值:「v1 四条营销句」与「块内零外链」。
  // 其中两条陌生人根本无从核验(「专注服务科技行业申请人的经验」/
  // 「致力于诚实、透明和文化敏感的服务」),而整块一条注册处链接都没有——
  // run1 记在本块名下的那条深链其实在 hero。
  //
  // ⛔ 这些字符串里**没有**的东西,以及为什么。两条 CICC 注册处事实。它们住在
  // `home.trust.licensedSince` / `home.trust.noDiscipline`(逐字段转写于
  // docs/research/register-facts-2026-07-29.md,由 T234 (b) 对该档冻结),
  // `page.tsx` 把**那两个键**渲进第 1、3 行,此处的值只作事实外面的框:
  //   第 1 行 →「2021 年起持牌 RCIC · 受 CICC 监管」
  //   第 3 行 →「零纪律处分记录 · 可在 CICC 官方注册表上验证 ↗」
  // 关于**可变**注册处的受监管陈述必须一次编辑即可全站撤下;在此另抄一份,
  // 就会活过那次编辑。`homeFace` §m 在本词典块里发现任一条事实即红——这就是查抄袭的牙。
  //
  // 第 2、4 行不含注册处事实,且**逐字**就是基准站的 `<li>` 文本节点
  // (`site/zh/index.html` §顾问区),§m 按精确成员判定,改一个字就不再匹配来源。
  // 第 4 行的语言对同时是信任条的同一枚 token(`home.credibility.bilingual`)。
  'home.consultant.qual1': '受 CICC 监管',
  'home.consultant.qual2': '专注科技与 STEM 人才移民路径',
  'ui.flipCard.flipBack': '翻回正面',
  // 注册处链接自身的标签:整个从句就是链接,读屏器的链接列表里读到的
  // 是「这条链接去核验什么」,而不是孤零零一个「CICC」
  'home.consultant.qual3': '可在 CICC 官方注册表上验证',
  'home.consultant.qual4': '双语服务：English · 中文',
  'home.consultant.readMore': '阅读完整简介',
  'home.consultant.desc': '作为 Think Forward Immigration Consulting 的创始人兼首席顾问，Yansi He 在帮助科技专业人士及其家庭实现加拿大移民目标方面拥有丰富经验。她成功指导了众多来自领先科技公司的员工完成复杂的移民途径，深刻理解技术人才在当今竞争激烈环境中面临的独特挑战。秉持诚实、透明和文化敏感的服务理念，Yansi 创立了 Think Forward，旨在帮助更多个人和家庭以信心和清晰的方向完成他们的加拿大移民之旅。',

  
  // [T262] 换成基准站的标题(`site/zh/index.html` §服务),取代 v1 的「我们的服务」——
  // run2 §5b 首页第二处发现,也是本区最后一个还属于「我方措辞」而非基准站的词。
  // 它说的是这家所做的事,而不是这些服务归谁;此值现已并入 `homeFace` §i 的
  // T240 逐字成员集,回退到 v1 标题即在那里变红。
  'home.services.title': '移民服务',
  // [T240] 六张服务卡 —— 与本站实际发布的六个服务专页一一对应。
  //
  // 原来的四个键(`pr` / `work` / `family` / `lmia`)是 Readdy 时代的**分类法**
  // (「永久居民途径」「工作和学习许可」),与站内其他地方都不一致:导航、页脚、
  // /services 都是同样的六个专页,只有首页还把业务分成四个点不进去的桶。此处**退役**,不是改名。
  //
  // ⚠ 逐字转写,非创作。下列每一条都是基准站的**文本节点原文**,
  // `homeFace.test.tsx` §i 每次运行都会重读基准站文件比对,改一个字就红:
  //   zh → docs/design/rebuild-v0b7764f/site/zh/index.html §服务
  //   (en 侧的来源与「为什么不是 en index 的那一套」见英文词典同处注释)
  'home.services.eyebrow': '我们能为你做什么',
  // `%LINK%` 标的是费用页链接在句中的位置,**不是** i18next 占位符
  // (`{{…}}` 会让 i18next 报警并把花括号留在页面上)。整句连标点作为一个字符串,
  // 任何一半都无法单独漂离基准站。
  // [T260 · B1-am2] 指针不得比目标活得久——随表同撤(2026-07-31)。
  // [T280 · S2] B1-am2 原句 → Q5 新裁 2026-08-02 owner 解钉改锚:owner 明示解除
  // B1-am2 的逐字钉(账本 §5-R,log 709「改锚到合同」)——「书面固定报价」文件并不存在,
  // 委托协议才存在。新句=T275 规范对的 home 位缩形,保留 %LINK% 指针;homeFace §i 逐字钉。
  'home.services.lead': '全案费用以书面形式写入您签署的委托协议——任何后续付款之前。详见%LINK%。',
  'home.services.leadLink': '费用页',
  'home.services.learnMore': '了解更多',
  'home.services.expressEntry.title': 'EE 快速通道 — STEM 与 CEC',
  'home.services.expressEntry.desc': '通过 STEM 类别定向抽选和加拿大经验类（CEC）申请联邦技术移民。决定递交前，先做指示性 CRS 估分。',
  'home.services.bcPnpTech.title': 'BC PNP Tech 科技人才省提名',
  'home.services.bcPnpTech.desc': '面向 BC 省科技从业者的省提名——永久性项目，对符合条件的职业进行定向定期邀请。',
  'home.services.spousal.title': '配偶及家庭担保',
  'home.services.spousal.desc': '担保配偶、伴侣或受抚养子女来加拿大——境内、境外申请，逐行逐项准备。',
  'home.services.pgwp.title': '学签与毕业工签 PGWP',
  'home.services.pgwp.desc': '含省级证明信（PAL）要求的学签申请、PGWP 毕业工签申请，以及从第一天开始的留学转移民路径规划。',
  'home.services.c11.title': 'C11 企业家工签',
  'home.services.c11.desc': '面向计划在加拿大创办或收购企业的创业者——从商业可行性到工签申请的整体规划。',
  'home.services.superVisa.title': '父母祖父母超级签证',
  'home.services.superVisa.desc': '为父母和祖父母办理长期访客身份——收入要求与医疗保险，一次性正确处理。',
  'home.services.view': '查看所有服务',
  
  // ── [T244] 收尾 CTA band —— T240 的 teal-50 形不动,换的是文案与阶梯 ──
  //
  //   · 标题原为「准备开始您的旅程了吗?」(模板话);基准站问的是读者真正的问题,
  //     并用免费那一级作答:「不知道从何开始？先做 10 分钟免费评估。」
  //   · `home.cta.desc` **退役**而非改写:基准站的 band 没有第二行,而我们那一行
  //     (「迈出实现加拿大梦想的第一步」)正是这次换装要离开的语域。t95 的 HOME_KEYS
  //     同 commit 摘掉该键——退役键留在文件里 = 一次 merge 冲突就回滚(T240 先例)。
  //   · band 现在按基准站的顺序同时承载阶梯两级(I29):免费评估是**唯一实心主 CTA**,
  //     付费咨询是它旁边更安静的次级。此前,还没准备付钱的读者在收尾区无处可点。
  //
  // ⛔ 金额写法 —— 记档偏离,以及它为什么安全:基准站写「预约 $99 咨询」,此处作「CAD $99」,
  // 即本站其余每一处金额的写法(`pricing.consultation.price`、预约流十处)也是
  // `priceConfig.CONSULTATION.display` 持有的形。加拿大公司站上的裸「$99」正是 CAD 前缀
  // 要消除的歧义。`homeFace` §k 断言本键的金额 token **就是** `CONSULTATION.display`,
  // 所以词典永远无法与 Stripe 实际收取的金额漂开——逐字照抄反而没有这个性质。
  'home.cta.title': '不知道从何开始？先做 10 分钟免费评估。',
  'home.cta.assess': '开始免费评估',
  'home.cta.button': '预约 CAD $99 咨询',
  
  // [T240] 客户故事区的两种状态。
  //
  // `eyebrow` + `title` 逐字取自基准站 site/zh/index.html §客户评价预览,
  // 且**只在同意闸有东西可展示时**才渲染。今天没有——CV-34 记录着那六条引语的
  // 书面同意仍然欠着——所以本区渲染替位形,文案取自 `src/pages/testimonials/copy.ts`
  // (A2 三层信任架构,已在 /testimonials 上线)。标题与卡片一样受闸控制,理由相同:
  // 在一条客户的话都没有的区块上写「真实个案，经客户书面同意后分享」,
  // 是在为不在页面上的材料背书。
  //
  // `home.success.subtitle` 已**退役**:基准站预览区没有副标题,而旧串
  // (「真实客户在我们的指导下实现加拿大移民目标的真实经历」)正是 CV-34 下架的
  // 那批结果叙事本身。
  'home.success.eyebrow': '客户故事',
  'home.success.title': '真实个案，经客户书面同意后分享',
  // 基准站 zh 版没有这条链接(其注释写明 zh 客户评价专页属后续批次),
  // 而本站的 /zh/testimonials 是在产的 —— 故此条是英文串的**翻译**而非转写,已在卡上标明。
  'home.success.readMore': '阅读更多客户故事',

  // [T235] 我们的承诺 —— 逐字取自基准站 site/zh/index.html §我们的承诺
  // (标题 + 链接文案),不是从英文转译。承诺条目本身不入词典:
  // 它们在 src/pages/pricing/priceConfig.ts 的 COMMITMENTS 单源,两页同 import。
  'home.commitments.title': '我们的承诺——白纸黑字,不是形容词',
  'home.commitments.priceList': '查看完整价目',

  // About Page
  'about.hero.title': '关于 Think Forward Immigration',
  'about.hero.subtitle': '诚实、透明、以客户为中心的加拿大移民指导',
  
  'about.consultant.title': '认识您的顾问',
  'about.consultant.subtitle': 'Yansi He, RCIC R708210',
  'about.consultant.desc': 'Yansi He 是 Think Forward Immigration Consulting 的创始人兼首席顾问，作为持牌加拿大移民顾问(RCIC)拥有丰富的专业经验。她在协助科技专业人士和来自领先公司的技术人才方面拥有卓越的成功记录，在快速通道、省提名计划和 LMIA 支持的工作许可等复杂移民途径方面积累了深厚的专业知识。她的专业方法专注于清晰、准确和支持性的客户体验。深刻理解移民所面临的挑战，Yansi 创立了 Think Forward，使命是根据每位客户的独特情况和目标提供个性化指导，帮助更多人充满信心地实现他们的加拿大梦想。',
  
  'about.values.title': '我们的核心价值观',
  'about.values.integrity.title': '诚信',
  'about.values.integrity.desc': '我们提供诚实的评估和现实的期望',
  'about.values.transparency.title': '透明',
  'about.values.transparency.desc': '关于流程、时间表和费用的清晰沟通',
  'about.values.cultural.title': '文化敏感性',
  'about.values.cultural.desc': '为来自各种背景的客户提供尊重的服务',
  'about.values.innovation.title': '创新',
  'about.values.innovation.desc': '针对复杂案例的战略思维和创造性解决方案',
  'about.values.success.title': '客户成功',
  'about.values.success.desc': '您的成功就是我们的成功',
  
  'about.approach.title': '我们的方法',
  'about.approach.desc': '我们相信清晰的解释、尊重的沟通和循序渐进的指导。我们的目标是帮助您了解移民过程的每个阶段,使您能够对在加拿大的未来做出明智的决定。我们花时间倾听您的故事,评估您的选择,并制定符合您目标的个性化策略。',
  
  'about.success.title': '客户成功案例',
  'about.success.subtitle': '真实客户在我们的指导下实现加拿大移民目标的真实经历',
  'about.success.case1.quote': '高效专业的服务 - 帮助我在创纪录的时间内获得了工作许可！指导清晰，流程顺畅。',
  'about.success.case1.name': 'Sarah Chen',
  'about.success.case1.type': '工作许可客户',
  'about.success.case2.quote': 'Yansi 为我的永居申请制定的策略非常完美。她理解我的科技背景，帮助我最大化了 CRS 分数。现在我已经是永久居民了！',
  'about.success.case2.name': 'Raj Patel',
  'about.success.case2.type': '快速通道客户',
  'about.success.case3.quote': '在整个家庭担保过程中提供了出色的支持。他们让复杂的流程变得易于管理，并在每一步都让我们了解最新情况。',
  'about.success.case3.name': 'Maria Garcia',
  'about.success.case3.type': '家庭担保客户',
  'about.success.readMore': '阅读更多成功案例',
  
  // Contact Page
  'contact.hero.title': '联系我们',
  'contact.hero.subtitle': '联系我们讨论您的加拿大移民之旅',
  
  'contact.form.title': '给我们留言',
  'contact.form.notice': '如需立即获得常见问题的答案，请使用右下角的AI助手。如需案件评估，请预约咨询。',
  'contact.form.inquiryType': '咨询类型',
  'contact.form.selectInquiryType': '请选择咨询类型',
  'contact.form.inquiryTypes.consultation': '预约 / 咨询相关问题',
  'contact.form.inquiryTypes.general': '一般问题',
  'contact.form.inquiryTypes.employer': '雇主 / 招聘(LMIA、GTS)',
  'contact.form.inquiryTypes.support': '现有客户支持',
  'contact.form.inquiryTypes.partnership': '合作 / 媒体 / 其他',
  'contact.form.name': '您的姓名',
  'contact.form.email': '您的邮箱',
  'contact.form.briefSummary': '简要说明（最多200字）',
  'contact.form.noSensitiveInfo': '请勿在此处包含敏感个人信息。',
  'contact.form.minCharHint': '💡 请至少填写 50 个字符的真实咨询内容，例如：您的背景、移民目标、具体问题等。',
  'contact.form.message': '您的留言',
  'contact.form.messagePlaceholder': '请简要说明您的咨询内容...',
  'contact.form.disclaimer': '我理解 Think Forward Immigration 不通过电子邮件提供具体的法律建议。此表单仅用于行政或预约咨询。',
  'contact.form.disclaimerIAgree': '我已阅读并同意',
  'contact.form.termsOfService': '服务条款',
  'contact.form.and': '和',
  'contact.form.privacyPolicy': '隐私政策',
  'contact.form.noRelationship': '，并且我理解提交此表单不会建立顾问-客户关系。',
  'contact.form.submit': '发送消息',
  'contact.form.success': '感谢！您的消息已成功发送。',
  'contact.form.error': '抱歉，发送消息时出错。请重试。',
  'contact.form.errorMissingFields': '请填写所有必填字段。',
  'contact.form.errorMessageTooShort': '请提供更详细的信息（至少 50 个字符），例如：您的背景、移民目标和具体问题，这样我们才能更好地帮助您。',
  'contact.form.errorCheckboxRequired': '请勾选复选框以同意服务条款和隐私政策后再提交。',
  'contact.form.errorSpam': '您的消息内容过于简短或笼统。请提供更具体的移民咨询详情（至少 50 个字符的有意义内容）。',
  'contact.form.charCount': '个字符',
  'contact.form.charNeeded': '⚠️ 还需要至少 {count} 个字符',
  'contact.form.charSufficient': '✓ 长度符合要求',
  'contact.form.errorInvalidEmail': '请输入有效的电子邮件地址。',
  'contact.form.errorInvalidData': '请检查您的输入并重试。',
  'contact.form.errorTooManyRequests': '请求过多。请稍等片刻后再试。',
  'contact.form.errorServerError': '服务器错误。请稍后重试。',
  'contact.form.errorNetwork': '网络错误。请检查您的网络连接并重试。',
  'contact.form.errorGeneric': '发生错误',
  
  'contact.info.title': '联系信息',
  'contact.info.consultant': '首席顾问，RCIC R708210',
  'contact.info.email': '邮箱',
  'contact.info.phone': '电话',
  'contact.info.location': '地址',
  'contact.info.vancouver': '大温哥华(本拿比),BC',
  
  'contact.skipWait.title': '跳过等待',
  'contact.skipWait.desc': '准备立即开始？直接预约我们的 RCIC 顾问咨询。',
  'contact.skipWait.button': '预约咨询',
  
  'contact.cta.title': '准备开始了吗?',
  'contact.cta.desc': '预约咨询,讨论您的移民目标并探索您通往加拿大的途径。',
  'contact.cta.button': '预约咨询',
  
  // Footer
  'footer.company': 'Think Forward Immigration Consulting',
  'footer.license': 'RCIC 执照: R708210',
  'footer.description': '位于大温哥华(本拿比)，为全球科技专业人士和家庭提供战略性移民解决方案。',
  // [T235] 页脚第一栏改为基准站的「我们的服务」(每个服务页一条链)。
  // 只有栏标题入词典 —— 六条标签读 src/data/programsData.json,
  // 与目标页同源,不会各写各的。
  'footer.services.title': '我们的服务',
  'footer.company.title': '公司',
  'footer.contact.title': '联系方式',
  'footer.contact.address': '大温哥华(本拿比),BC',
  'footer.contact.rcic': '持牌加拿大移民顾问 (RCIC)',
  'footer.quickLinks': '快速链接',
  'footer.social': '关注我们',
  'footer.copyright': '© {{year}} Think Forward Immigration Consulting. 版权所有。',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.powered': '网站建设',

  // Pricing Page
  pricing: {
    hero: {
      title: '服务费用与定价',
      subtitle: '我们相信透明和公平的定价。每个案例都是独特的，我们会根据您的具体情况提供个性化报价。',
    },
    consultation: {
      title: '初次咨询套餐',
      subtitle: '与专业 RCIC 一对一咨询',
      price: 'CAD $99',
      currency: '加元',
      included: '套餐包含',
      feature1: {
        title: '与 RCIC 进行 45 分钟视频通话',
        desc: '与持牌移民顾问深入讨论',
      },
      feature2: {
        title: '资格评估',
        desc: '全面评估您的移民资格',
      },
      feature3: {
        title: '战略路线图',
        desc: '定制移民策略和时间规划',
      },
      feature4: {
        title: '费用全额抵扣',
        desc: '签约全套服务后，咨询费用全额抵扣',
      },
      bonus: {
        title: '特别优惠：',
        desc: '如果您决定签约我们的全套移民服务，此咨询费用将全额从服务费中扣除。',
      },
      cta: '预约咨询',
    },
    process: {
      title: '我们的服务流程',
      desc: '透明、专业、高效的三步服务流程，确保您的移民之路清晰明确',
      step1: {
        title: '1. 付费咨询',
        desc: '我们深入分析您的具体情况，评估资格，制定初步策略',
      },
      step2: {
        title: '2. 策略与报价',
        desc: '我们提供量身定制的移民方案和透明的服务费用说明',
      },
      step3: {
        title: '3. 签约启动',
        // [T280 · Q9]「立即开始申请流程」→ 看得见的动作形(owner,§5-R Q9,
        // 2026-08-02):开案由顾问在员工台手动完成,「立即」没有机器含义——
        // 客户真正看得见的动作是那封邀请邮件(invite-send),句子现在承诺的就是它。
        desc: '协议签署后，我们即为你开案，并发送安全的资料填写链接。',
      },
    },
    philosophy: {
      title: '我们的收费理念',
      desc1: '作为持牌移民顾问，我们深知每个客户的情况都是独特的。案件的复杂程度、所需时间和资源都会因人而异。',
      desc2: '因此，我们不提供统一定价，而是在充分了解您的情况后，为您提供量身定制的报价方案。这确保您只为真正需要的服务付费，获得最大的价值。',
    },
    whyQuote: {
      title: '为什么需要个性化报价？',
      desc: '每个移民案件都有其独特性，我们相信透明和公平的定价应该基于您的实际需求',
      reason1: {
        title: '案件复杂度不同',
        desc: '有些案件可能需要额外的文件准备、翻译或法律分析，这些都会影响服务成本',
      },
      reason2: {
        title: '公平定价原则',
        desc: '简单的案件不应该支付复杂案件的费用，我们确保每位客户都获得公平的价格',
      },
      reason3: {
        title: '透明沟通',
        desc: '在咨询过程中，我们会详细解释费用构成，让您清楚了解每一项服务的价值',
      },
    },
    howToGet: {
      title: '如何获取您的个性化报价',
      subtitle: '简单三步，让我们的AI助手帮您预约咨询',
      step1: {
        title: '浏览我们的服务',
        desc: '访问"服务"页面，了解我们提供的各类移民服务，找到最适合您的项目',
        link: '查看所有服务',
      },
      step2: {
        title: '与AI助手对话',
        desc: '点击页面右下角的AI助手按钮，我们的AI助手会用您的语言（中文/英文）与您交流',
        note: '支持中文和英文',
      },
      step3: {
        title: '预约咨询',
        desc: 'AI助手会帮您预约与持牌移民顾问的咨询，讨论您的具体情况并获取个性化报价',
        note: 'CAD $99 咨询费',
      },
      cta: '立即与AI助手对话',
      note: '或者直接访问服务页面，选择您感兴趣的服务',
    },
    services: {
      title: '服务类别',
      subtitle: '我们提供全方位的加拿大移民服务，点击了解详情并获取报价',
    },
    pr: {
      title: '永久居民项目',
      express: {
        title: 'Express Entry（联邦快速通道）',
      },
      pnp: {
        title: '省提名项目（PNP）',
      },
      family: {
        title: '家庭担保移民',
      },
      economic: {
        title: '经济类移民项目',
      },
    },
    work: {
      title: '工作许可',
      lmia: {
        title: 'LMIA 支持的工作许可',
      },
      permit: {
        title: '雇主特定工作许可',
      },
      openPermit: '开放式工作许可',
      extension: '工作许可延期',
    },
    study: {
      title: '学习许可',
      permit: {
        title: '学习许可申请',
      },
      pgwp: {
        title: '毕业后工作许可（PGWP）',
      },
      extension: '学习许可延期',
      coop: 'Co-op 工作许可',
    },
    other: {
      title: '其他服务',
      consultation: {
        title: '移民咨询评估',
      },
      review: {
        title: '案件审查与建议',
      },
      visitor: '访客签证延期',
      citizenship: '入籍申请',
    },
    getQuote: '获取报价',
    included: {
      title: '服务包含内容',
      item1: {
        title: '完整的案件准备',
        desc: '我们从头到尾处理所有表格、文件和提交。',
      },
      item2: {
        title: '持续沟通',
        desc: '在整个过程中定期更新并及时回答您的所有问题。',
      },
      item3: {
        title: '质量保证',
        desc: '提交前进行多次审查和质量检查以确保准确性。',
      },
    },
    howItWorks: {
      title: '获取报价流程',
      step1: {
        title: '联系我们',
        desc: '通过电话、邮件或在线表单与我们取得联系，简要说明您的移民需求。',
      },
      step2: {
        title: '初步咨询',
        desc: '我们将从咨询开始，了解您的背景、目标和具体情况。',
      },
      step3: {
        title: '收到个性化报价',
        desc: '基于您的案件评估，我们会提供详细的服务范围和费用说明。',
      },
      step4: {
        title: '开始合作',
        desc: '一旦您接受报价，我们将立即开始为您的移民梦想而努力。',
      },
    },
    notes: {
      title: '重要说明',
      note1: '所有费用均为专业服务费，不包括政府申请费、翻译费、公证费等第三方费用。',
      // [T275 · Q10] note2(「灵活的付款计划」)已按 owner 裁决退役(§5-R Q10:
      // 不提供分期,仓内亦零分期实现)。两本词典同步删键;/pricing 列表随删重排。
      note3: '首次咨询为付费 CAD $99 咨询。我们相信在您做出决定之前，应该充分了解所有选项。',
    },
    cta: {
      // T246 lands T245's parked ⑥ — mirrors the en swap (zip CTA band).
      // [T280 · S4] desc 第二事实改锚委托协议(owner,§5-R Q5 族——「书面固定
      // 报价」文件并不存在,合同才存在):T275 规范对按位缩,两不变量齐备
      // (载体=签署的委托协议;时点=任何后续付款之前)。
      title: '从 $99 咨询开始——签约后全额抵扣。',
      desc: '与持牌顾问进行 45 分钟视频通话——全案费用以书面形式写入您签署的委托协议，任何后续付款之前。',
      button: '预约 $99 咨询',
    },
  },

  // Testimonials Page
  testimonials: {
    hero: {
      title: '客户成功案例',
      subtitle: '真实案例展示我们如何帮助客户克服移民挑战，实现加拿大梦想。每个故事都展现了我们的专业策略和对客户成功的承诺。'
    },
    filter: {
      all: '全部案例',
      pr: '永久居民',
      work: '工作许可',
      family: '家庭担保',
      business: '商业移民',
      citizenship: '入籍'
    },
    cases: {
      case1: {
        role: '软件工程师',
        service: 'BC省提名科技类',
        story: '说实话，我当时真的慌了，因为工作许可快到期了，CRS分数又不够高。时间不多了，选择也不多。Yansi真的是救星！她主动介入，帮我和HR谈判争取省提名支持，而且提交速度超快。她的策略和快速行动改变了一切。3周就收到提名邮件，感觉像奇迹一样。太放心了！'
      },
      case2: {
        role: '市场经理',
        service: '配偶担保',
        story: '之前被拒签过一次后，我和妻子都崩溃了，特别害怕再试一次。我们不知道哪里出了问题，也不知道怎么改。Yansi完全重建了我们的信心。她写的解释信太厉害了——解决了签证官的每一个疑虑。她完全知道该说什么。今天我妻子终于落地温哥华了，真的太感谢Think Forward让我们家庭团聚。这是我们做过最好的决定。'
      },
      case3: {
        role: '平面设计师',
        service: '留学转PR（加拿大经验类）',
        story: '我差点错过PR机会！我没意识到PGWP快到期了。我差点就失去在加拿大的身份了。Yansi及时发现了申请加拿大经验类（CEC）的关键时间窗口。她的战略时机把握和细致的申请准备拯救了一切。我都不敢想如果没有她敏锐的眼光会怎样。最值得的投资。现在在多伦多开了自己的设计工作室。'
      },
      case4: {
        role: '退休父母',
        service: '父母超级签证',
        story: '我们只想多陪陪温哥华的孙子孙女，但是普通签证太麻烦了，每次只能待6个月。Yansi团队帮我们准备了超级签证的所有材料，连体检和保险都安排得妥妥当当。一切都处理得专业又仔细。一次就拿到了10年签证！现在我们可以一次待5年，真正参与到孙辈的生活中。太感谢了！'
      },
      case5: {
        role: '土木工程师',
        service: 'LMIA和工作许可',
        story: '我的雇主愿意担保我，但完全不知道怎么办LMIA。他们觉得流程太复杂，都快要放弃了。Yansi介入后，一步步指导他们的HR部门。她让整个过程变得简单，专业地处理了所有复杂的合规要求。多亏她的坚持，我终于拿到工作许可了。LMIA批了。现在正在通过加拿大工作经验走PR通道。'
      },
      case6: {
        role: '企业家',
        service: '商业移民',
        story: '把生意搬到加拿大感觉是个大麻烦。我不知道企业家移民要求从哪里开始。Yansi帮我规划了整个C11流程，让一切看起来很简单。她的商业背景在起草商业计划和策略时真的帮了大忙。现在我的公司在温哥华顺利运营了！生意成功建立。工作许可批了。现在还雇了加拿大员工。'
      },
      case7: {
        role: '长期居民',
        service: '入籍申请',
        story: '我的出入境记录一团糟，我特别害怕算错居住天数被拒。我有太多国际旅行记录了。Yansi和她的团队一条条核对我的护照章，确保100%准确。她仔细交叉核对了所有东西——机票记录、工作记录，所有的。拿到加拿大护照的感觉太棒了。入籍顺利批准，没有任何问题。在加拿大6年后，终于成为自豪的加拿大公民。'
      },
      case8: {
        role: '法语人士',
        service: '法语人士流动计划',
        story: '我完全不知道我的法语技能可以让我不用LMIA就拿工作许可！我还在准备漫长的LMIA申请，完全是浪费时间。Yansi告诉我这个法语人士项目，马上帮我准备好申请。整个过程超级简单。Merci beaucoup, Yansi！工作许可超快批准，不用LMIA。现在在蒙特利尔工作，为加拿大法语社区做贡献。'
      }
    },
    cta: {
      title: '从一次诚实的评估开始',
      desc: '预约一次由持牌顾问(RCIC)进行的付费咨询:我们审阅您的具体情况,说明哪些移民途径适用,并如实告诉您我们能做什么、不能做什么。',
      button: '预约咨询'
    }
  },

  // FAQ Page
  faq: {
    hero: {
      title: '常见问题',
      subtitle: '查找有关加拿大移民和我们服务的常见问题的答案。找不到您要找的内容？直接联系我们。',
    },
    sidebar: {
      title: '分类',
    },
    label: {
      source: '官方来源',
      asOf: '信息截至 2026 年 6 月——规则经常变动,请务必在 IRCC 官方网站(canada.ca)核实。',
    },
    categories: {
      general: '一般问题',
      pr: '永久居民',
      work: '工作许可',
      study: '学习许可',
      family: '家庭担保',
      process: '流程和时间',
      trust: '信任与合作',
      gettingStarted: '入门与要求',
    },
    contact: {
      title: '还有其他问题？',
      desc: '预约我们持牌移民顾问的咨询服务，获取针对您移民问题的个性化解答。',
      button: '预约咨询',
    },
  },

  footer: {
    mission: '您值得信赖的加拿大移民合作伙伴。我们提供专业指导和个性化解决方案，帮助您实现加拿大梦想。',
    company: {
      title: '公司'
    },
    licensing: {
      title: '监管与联系',
      authorized: 'Yansi He 持有加拿大移民及公民顾问学院(CICC)颁发的执照并受其监管,牌照号 R708210。',
      license: 'RCIC 执照：'
    },
    contact: {
      address: '大温哥华(本拿比),BC'
    },
    copyright: '© {{year}} Think Forward Immigration Consulting. 版权所有。',
    privacy: '隐私政策',
    terms: '服务条款',
    powered: '网站建设'
  },

  // Terms of Service Modal
  terms: {
    title: '服务条款',
    lastUpdated: '最后更新：2025年1月',
    close: '关闭',
    intro: {
      title: '引言',
      content: '欢迎访问 Think Forward Immigration Consulting。访问或使用我们的网站（thinkforwardic.com）即表示您同意遵守这些服务条款。在使用我们的服务或网站之前，请仔细阅读。'
    },
    disclaimer: {
      title: '重要法律免责声明',
      content1: '本网站提供的信息仅供一般参考之用，不构成法律建议、移民咨询或专业服务。',
      content2: '移民法律、法规和政策经常变化。虽然我们努力保持信息的时效性和准确性，但我们不对本网站上任何信息的完整性、准确性、可靠性或适用性作出任何陈述或保证。',
      content3: '您不应依赖本网站上的任何信息来替代专业移民咨询。有关您移民事务的具体建议，请预约我们持牌 RCIC 的付费咨询。'
    },
    relationship: {
      title: '不构成顾问-客户关系',
      content1: '仅仅浏览本网站、提交联系表格或发送电子邮件并不会在您与 Think Forward Immigration Consulting 或 Yansi He（RCIC）之间建立顾问-客户关系。',
      content2: '正式的顾问-客户关系仅在以下情况下建立：(1) 我们进行了初步咨询，(2) 我们书面同意代表您，以及 (3) 您签署了委托协议并支付了所需费用。'
    },
    accuracy: {
      title: '信息准确性',
      content1: '我们尽一切努力确保本网站上的信息准确且最新。但是，加拿大移民法律、法规、处理时间和政策会受到加拿大移民、难民和公民部（IRCC）及其他政府机构的频繁变更。',
      content2: '我们不保证本网站上的所有信息都反映最新的法律发展。请务必通过官方政府来源或通过我们 RCIC 的付费咨询来验证关键信息。'
    },
    copyright: {
      title: '知识产权和版权',
      content1: '本网站上的所有内容，包括但不限于文本、图形、徽标、图像、视频和软件，均为 Think Forward Immigration Consulting 的财产，受加拿大和国际版权法保护。',
      content2: '未经我们事先书面同意，您不得出于商业目的复制、分发、修改、传输或使用本网站的任何内容。允许个人非商业用途，但需注明出处。'
    },
    thirdParty: {
      title: '第三方链接',
      content: '本网站可能包含指向第三方网站的链接（包括政府网站、教育机构和其他资源）。我们不控制或认可这些外部网站，也不对其内容、隐私政策或做法负责。访问第三方链接的风险由您自行承担。'
    },
    liability: {
      title: '责任限制',
      content: '在法律允许的最大范围内，Think Forward Immigration Consulting、Yansi He 及我们的关联方不对因您使用本网站或依赖本网站提供的任何信息而产生的任何直接、间接、附带、后果性或惩罚性损害承担责任。这包括但不限于利润损失、数据丢失或移民申请被拒的损害。'
    },
    privacy: {
      title: '隐私和数据保护',
      content: '您对本网站的使用也受我们隐私政策的约束。我们致力于根据加拿大隐私法（包括《个人信息保护和电子文件法》(PIPEDA)）保护您的个人信息。请查看我们的隐私政策，了解我们如何收集、使用和保护您的数据。'
    },
    law: {
      title: '适用法律和管辖权',
      content: '这些服务条款受不列颠哥伦比亚省法律和适用的加拿大联邦法律管辖并据此解释。因这些条款或您使用本网站而产生的任何争议应受不列颠哥伦比亚省法院的专属管辖。'
    },
    changes: {
      title: '条款变更',
      content: '我们保留随时修改这些服务条款的权利，恕不另行通知。更改将在发布到本网站后立即生效。您在任何更改后继续使用本网站即表示您接受修订后的条款。我们鼓励您定期查看这些条款。'
    },
    contact: {
      title: '联系信息',
      content: '如果您对这些服务条款有任何疑问，请联系我们：'
    }
  },

  // Privacy Policy Modal
  privacy: {
    title: '隐私政策',
    lastUpdated: '最后更新：2025年1月',
    close: '关闭',
    intro: {
      title: '引言',
      content: 'Think Forward Immigration Consulting（"我们"）致力于保护您的隐私和个人信息。本隐私政策说明了当您访问我们的网站或使用我们的服务时，我们如何收集、使用、披露和保护您的信息。作为持牌加拿大移民顾问（RCIC）公司，我们遵守加拿大移民和公民顾问学院（CICC）以及加拿大隐私法规定的严格保密和隐私标准。'
    },
    cicc: {
      title: 'CICC 保密标准',
      content1: '作为加拿大移民和公民顾问学院（CICC）的持牌成员，我们受 CICC 专业行为准则的约束，该准则要求我们对所有客户信息保持最严格的保密。',
      content2: '我们将所有客户通信、文件和案件详情视为严格保密和特权信息。即使在我们的专业关系结束后，这种保密义务仍然持续。',
      content3: '未经您的明确同意，我们绝不会与第三方共享您的个人信息，除非法律或专业法规要求。'
    },
    collection: {
      title: '我们收集的信息',
      intro: '我们收集信息仅用于提供专业移民咨询服务。我们可能收集的信息类型包括：',
      item1: {
        title: '个人身份信息',
        desc: '姓名、出生日期、护照详情、联系信息（电子邮件、电话、地址）以及移民申请所需的其他身份证件。'
      },
      item2: {
        title: '移民案件详情',
        desc: '教育证书、工作经历、语言测试成绩、家庭信息、旅行历史以及与您的移民评估和申请相关的其他详情。'
      },
      item3: {
        title: '财务信息',
        desc: '我们服务的付款信息、资金证明文件以及移民目的所需的其他财务记录。'
      },
      item4: {
        title: '网站使用数据',
        desc: '当您访问我们的网站时，我们可能会通过 Cookie 和类似技术自动收集某些技术信息，如 IP 地址、浏览器类型、访问的页面和在页面上花费的时间。'
      }
    },
    usage: {
      title: '我们如何使用您的信息',
      intro: '我们仅将您的个人信息用于合法的移民咨询目的：',
      item1: '评估您申请加拿大移民项目的资格',
      item2: '代表您准备和提交移民申请',
      item3: '与您沟通您的案件并提供更新',
      item4: '与加拿大移民、难民和公民部（IRCC）及其他政府机构通信',
      item5: '按照 CICC 法规和加拿大法律的要求保持准确的记录'
    },
    sharing: {
      title: '信息共享和披露',
      content1: '我们不会出于营销目的出售、交易、出租或与第三方共享您的个人信息。您的信息受到最高级别的保密处理。',
      content2: '我们仅在以下有限情况下披露您的信息：',
      exception1: '向政府机构（IRCC、CBSA、省级移民办公室）披露，以处理您的移民申请所必需',
      exception2: '向授权的第三方服务提供商（翻译、证书评估机构、体检医生）披露，仅在您的申请所必需且仅在您同意的情况下',
      exception3: '法律、法院命令或法律程序要求时，或为保护我们的合法权利'
    },
    security: {
      title: '数据安全',
      content1: '我们实施行业标准的安全措施，以保护您的个人信息免遭未经授权的访问、披露、更改或破坏。我们的安全实践包括：',
      measure1: '所有在线通信的加密数据传输（SSL/TLS）',
      measure2: '安全的、受密码保护的文件存储系统，访问受限',
      measure3: '定期对我们的系统进行安全审计和更新',
      measure4: '员工保密义务和数据保护培训',
      content2: '虽然我们采取一切合理的预防措施来保护您的信息，但没有任何电子传输或存储方法是 100% 安全的。我们不能保证绝对安全，但致力于使用最佳实践来保护您的数据。'
    },
    retention: {
      title: '数据保留',
      content1: '我们仅在实现收集目的所需的时间内以及遵守法律和监管要求所需的时间内保留您的个人信息。',
      content2: '根据 CICC 法规，我们需要在服务结束后至少保留客户文件 6 年。在此保留期后，我们会安全销毁或匿名化您的个人信息。'
    },
    rights: {
      title: '您的隐私权',
      intro: '您对您的个人信息拥有以下权利：',
      right1: '访问权：您可以请求访问我们持有的关于您的个人信息',
      right2: '更正权：您可以请求更正任何不准确或不完整的信息',
      right3: '撤回同意：您可以撤回对您信息某些用途的同意（受法律和合同义务的约束）',
      right4: '投诉权：如果您认为您的隐私权受到侵犯，您可以向加拿大隐私专员提出投诉'
    },
    cookies: {
      title: 'Cookie 和跟踪技术',
      content1: '我们的网站使用 Cookie 和类似技术来改善用户体验、分析网站流量和了解访客行为。Cookie 是存储在您设备上的小文本文件。',
      content2: '您可以通过浏览器首选项控制 Cookie 设置。但是，禁用 Cookie 可能会影响您使用我们网站某些功能的能力。'
    },
    changes: {
      title: '隐私政策变更',
      content: '我们可能会不时更新本隐私政策，以反映我们实践或法律要求的变化。我们将在我们的网站上发布更新的政策，并修订"最后更新"日期。我们鼓励您定期查看本政策。'
    },
    contact: {
      title: '隐私咨询联系方式',
      content: '如果您对本隐私政策或我们如何处理您的个人信息有任何疑问、顾虑或请求，请联系我们：'
    }
  },

  bookConsultation: {
    header: '预约您的移民策略咨询',
    subheader: '与持牌加拿大移民顾问（RCIC）进行一对一咨询。获得个性化的法律评估和路线图。',
    step1: {
      label: '了解详情',
    },
    step2: {
      label: '选择时间',
    },
    step3: {
      label: '完成付款',
    },
    processNote: {
      title: '预约流程',
      desc: '只需三个简单步骤完成您的预约：',
      step1: '查看咨询套餐内容并同意相关条款。',
      step2: '选择适合您的日期和时间。所有时间均以您的本地时区显示。',
      step3: '支付 CAD $99 确认预约。您将收到官方收据。',
    },
    consent: {
      title: '必要同意',
      termsPrefix: '我已阅读并同意',
      termsLink: '服务条款',
      termsSuffix: '',
      privacyPrefix: '我已阅读并同意',
      privacyLink: '隐私政策',
      privacySuffix: '',
      agreeAll: '我同意服务条款和隐私政策。',
      required: '请先同意上方必要的条款以继续。',
    },
    summary: {
      title: '您的预约',
      date: '日期',
      time: '时间',
      name: '姓名',
      email: '邮箱',
      fee: '咨询费用',
      pacificTime: '太平洋时间',
      yourLocalTime: '您的当地时间',
      consultant: '顾问',
    },
    heroAlt: '移民咨询',
    timePicker: {
      // [T288] 营业时间由时间窗渲染（src/lib/slots.ts → TimeSlotPicker），不再写死数字；
      // 「太平洋时间」为 owner 2026-09-15 修正案——咨询时间恒按太平洋时区。
      hint: '选择您的45分钟在线咨询的日期和时间。咨询时间为周一至周五 {{start}} 至 {{end}}（太平洋时间），并需至少提前48小时预约。',
      localTimeNote: '每个时段下方会显示您的当地时间。',
      availableFor: '{{date}}的可预约时间',
      selectDate: '请选择日期',
      today: '（今天）',
      consultantTimeParen: '（时间以顾问所在时区为准：{{tz}}）',
      consultant: '顾问：',
      loading: '正在加载可预约时段…',
      noSlots: '该日期暂无可预约时段',
      tryAnother: '请试试其他日期，或稍后再来看看',
      morning: '上午',
      afternoon: '下午',
      selectedTime: '已选时间',
      consultantTime: '顾问当地时间（{{tz}}）',
      yourLocalTime: '您的当地时间：',
      yourName: '您的姓名',
      namePlaceholder: '请输入您的全名',
      continuePayment: '继续付款',
    },
    back: '返回',
    payment: {
      title: '确认您的预约',
      desc: '需要支付 CAD $99 以确认您的咨询名额。如果您后续委托我们办理全套移民服务，此费用可全额抵扣。',
      // [T275 · Q3] receiptTitle / receiptDesc 已按 owner 裁决退役(承诺账本 §5-R Q3):
      // 「官方收据/自动发送/供 IRCC 提交」句落空——刷卡收据不带执业主体信息,不满足该用途。
      // 两本词典同步删键(T268 孤儿纪律),渲染块随删。
      termsPrefix: '我理解 CAD $99 是一次性 Initial Assessment 咨询的不可退款费用。我同意',
      termsLink: '服务条款',
      termsSuffix: '。',
      privacyPrefix: '我已阅读并同意',
      privacyLink: '隐私政策',
      privacySuffix: '，并同意为本次咨询收集和使用我的信息。',
      cta: '支付 CAD $99 并确认预约',
      processing: '处理中...',
      checkboxRequired: '请同意付款条款和隐私政策以继续。',
      secureNote: '付款由 Stripe 安全处理。我们不会存储您的卡片信息。',
      noTime: '未找到预约时间。请返回第 2 步选择时间段后再进行付款。',
      emailLabel: '电子邮箱',
      emailNeeded: '需要电子邮箱以接收付款收据',
      emailPlaceholder: '请输入您的电子邮箱',
      emailWhy: 'Stripe 需要电子邮箱来发送您的付款收据和预约确认。',
    },
    cta: {
      step1: '选择时间',
    },
    seo: {
      title: '预约咨询 | CAD $99 初步评估 | Think Forward 移民咨询',
      description: '预约与持牌 RCIC Yansi He 的 45 分钟一对一咨询。CAD $99 初步评估包含资格评估和策略路线图。',
      keywords: '预约移民咨询, RCIC 咨询, 加拿大移民评估, CAD $99 咨询, 温哥华移民顾问预约',
    },
    disclaimer: {
      text: '预约即表示您同意我们的',
      terms: '服务条款',
      and: '和',
      privacy: '隐私政策',
    },
  },

  bookingSuccess: {
    title: '预约已确认！',
    subtitle: '感谢您的付款。您的咨询已成功锁定。',
    generating: '正在生成您的会议链接…',
    generatingSlow: '会议链接生成时间比预期稍长。请放心——链接稍后会通过邮件发送给您。',
    meeting: {
      title: '您的视频会议房间',
      desc: '我们已为您的咨询创建了一个专属视频会议房间。请保存此链接——预约时间到来时您需要用它加入会议。',
      roomLabel: '会议链接',
      joinNow: '打开会议房间',
      noDownload: '无需下载或注册账号。直接在浏览器中使用。在预约时间点击链接即可加入。',
    },
    emailTitle: '接下来会发生什么',
    emailDesc: '您将很快收到三封邮件：',
    emailItem1: 'Stripe 发送的付款收据，包含交易详情。',
    emailItem2: '我们发送的确认邮件，包含您的预约详情和操作指引。',
    emailItem3: '准备指南，帮助您为咨询做好充分准备。',
    nextSteps: {
      title: '您可以期待什么',
      step1: {
        title: '准备您的文件',
        desc: '准备好您的护照、简历以及任何与移民相关的文件，以便顾问审阅。',
      },
      step2: {
        title: '加入视频通话',
        desc: '在预约时间，点击上方的会议链接加入视频咨询。无需下载任何软件。',
      },
      step3: {
        title: '收到您的路线图',
        desc: '咨询结束后，您将收到一份书面策略路线图及后续步骤。',
      },
    },
    cta: {
      services: '探索我们的服务',
      home: '返回首页',
    },
    seo: {
      title: '预约已确认 | Think Forward 移民咨询',
      description: '您的咨询预约和付款已成功确认。',
      keywords: '预约确认, 移民咨询已确认',
    },
  },

  about: {
    // [T216] `altCiccMember` 随其标注的 RCIC 称号标记图一并退场(CV-33);
    // 原位改用同一主张的文字件:牌照号 + 可查证的官方注册名录(methodology 先例)。
    verify: {
      licence: 'RCIC R708210',
      register: '在 CICC 官方注册名录查证',
      // [T243] ground truth「查牌三步」区块(site/about.html §VERIFY;zh/about.html 同区)。
      // 只写流程,不写注册表本身没有的任何规则值;脚注外链=本仓 guidesData.json 已发布的
      // canada.ca 链接(零新外链)。zip 的第一人称改为事务所口径:页面由事务所发布,
      // 读者查的是**牌照**。
      steps: {
        eyebrow: '别只听我们说——去验证',
        title: '三步查到我们的牌照',
        lead: '任何网站都能印上「持牌顾问」四个字;只有 CICC 官方注册名录能告诉你档案上到底写了什么。查一次不到一分钟——在我们开口之前、在你付款之前、在你交出任何一份材料之前。',
        s1: {
          title: '打开 CICC 官方注册名录',
          body: '它由监管机构发布,不是由我们发布。',
        },
        s2: {
          title: '搜索牌照号或姓名',
          body: '牌照号 R708210,或姓名 Yansi He。',
        },
        s3: {
          title: '自己核对状态',
          body: '档案会显示牌照类别、生效日期、当前状态,以及有无纪律处分记录。',
        },
        footnote:
          '如果一位代理人被问到牌照号时含糊其辞,那本身就是答案。在加拿大,只有 CICC 持牌顾问、加拿大省律师公会律师或魁北克公证人可以收费提供移民建议或代理——任何人都可以在 canada.ca 上查:',
        footnoteLink: '如何使用移民代理人 — canada.ca',
      },
    },
    altConsultation: '专业咨询',
    altOffice: 'Think Forward 移民咨询办公室',
    // ── [T243] 注册处事实(逐字) ──────────────────────────────────────────────
    // source_url: https://register.college-ic.ca/Public-Register-EN/Licensee/Profile.aspx?ID=15486
    // verified_at: 2026-07-29 — 转录档:docs/research/register-facts-2026-07-29.md
    // 下列每个值都照抄该转录,不改写、不取整:Licence `Class L2 - RCIC`、Start `2021-11-03`、
    // Status `Active`,以及四张纪律类表格全部 `There are no records`。措辞上限照该档执行:
    // 持牌声明**带到日**(所以它是注册表的事实,不是被取整过的),纪律声明写成
    // 「某一日注册表上的内容」,页面同时给出核对日期与深链——读者一键即可推翻。
    // 若注册表出现任何记录或状态非 Active,`record.licensed` / `record.discipline` **撤下**,
    // 不做措辞变通(转录档 §re-verification)。
    record: {
      eyebrow: '执业履历',
      title: '可以核验的事实,不是宣传口号',
      licensed: '2021-11-03 起持牌——Class L2 - RCIC,状态 Active(有效)',
      discipline: 'CICC 官方注册名录上零纪律处分记录',
      focus: '执业方向:科技与 STEM 人才移民路径',
      based: '常驻大温哥华地区(本拿比)——以视频咨询进行',
      languages: '服务语言:中文 · English',
      checked:
        '牌照与纪律两栏取自 CICC 官方注册名录,核对日期 2026-07-29。两者随时可能变动——请自己打开实时档案核对:',
    },
    consultant: {
      eyebrow: '我们的顾问',
      hero: {
        title: '认识您的首席顾问',
        // [T243] ground truth 页首 H1 + lead(site/about.html §page-head),
        // 其中每一项**事实**换成我方真值:持牌年份取自上面的注册处转录,地点用本站
        // 其它各处已发布的写法(「大温哥华地区(本拿比)」——页脚、联系页、首页)。
        // zip 的「#R708210」改为本站惯用形 `RCIC R708210`(=`about.verify.licence`)。
        headline: 'Yansi He — 创始人暨首席顾问,RCIC R708210',
        intro: '自 2021 年起由加拿大移民及公民顾问管理局(CICC)发牌并监管。科技与 STEM 人才移民专家,常驻大温哥华地区(本拿比),以中文与 English 服务加拿大境内外的客户。',
        highlight1: {
          title: '持牌专家',
          desc: '持牌加拿大移民顾问（RCIC），确保完全合规。',
        },
        highlight2: {
          title: '战略方法',
          desc: '将复杂的法规转化为清晰的个性化移民路线图。',
        },
        highlight3: {
          title: '丰富经验',
          desc: '在各类加拿大移民个案上提供丰富而审慎的指导——从技术人才到家庭与企业。',
        },
        subtitle: 'Yansi He，持牌移民顾问 (R708210) | 科技与商业移民专家',
        bio1: '凭借在加拿大移民法方面的丰富经验，以及对科技和商业移民途径的专业专注，Yansi He 为客户在复杂移民场景中提供战略性路线图。',
        bio2: '作为持牌加拿大移民顾问（RCIC），Yansi 确保在整个移民过程中完全符合监管要求，同时为您的最佳利益发声。',
        bio3: '她在科技/STEM途径、省提名计划和商业移民方面的专业知识，为众多专业人士、家庭和企业家在加拿大建立生活提供支持。',
      },
      credentials: {
        licensed: '持牌 RCIC',
        tech: '科技/STEM 专家',
        business: '商业移民',
        complex: '复杂案例专家',
      },
    },
    // [T249] 三段散文→三行清单(密度深研 §2B/§3)。事实逐条保留,只去掉虚词
    // (「我们对…进行」「都会接受全面的…审查」「我们对…的承诺,确保」);
    // 零语义漂移由 src/pages/about/u7cAboutProse.test.tsx 的事实清单断言看守。
    standard: {
      title: '我们的专业标准',
      desc1: '对您的个人资料做严格的法律评估——为您确定最安全的永久居留途径。',
      desc2: '每一个案例:资格标准、文件要求、战略时机,逐项评估,以最大化您申请材料的强度。',
      desc3: '监管合规与透明沟通——让您了解移民旅程的每一步。',
    },
    foundation: {
      title: '我们的专业基础',
      subtitle: '建立在我们于整个移民旅程中始终恪守的原则之上。',
      integrity: {
        title: '诚信',
        desc: '公正的法律建议和透明的收费结构。没有隐藏费用，没有虚假承诺。',
      },
      expertise: {
        title: '专业知识',
        desc: '联邦和省级移民项目的专业知识，专注于科技/STEM和商业途径。',
      },
      dedication: {
        title: '专注',
        desc: '致力于您在加拿大的长期成功，从初次咨询到永久居留及以后。',
      },
    },
    intro: {
      title: '关于 Think Forward 移民咨询',
      // [T249] 公司名就在正上方的标题里,段首重复即虚词;其余事实全留
      // (专业移民咨询公司 · 不列颠哥伦比亚省温哥华 · 技术专业人士 · 科技工作者 ·
      // 商业企业家 · 加拿大移民系统 · 自信清晰)。
      desc: '一家位于不列颠哥伦比亚省温哥华的专业移民咨询公司。我们帮助技术专业人士、科技工作者和商业企业家自信清晰地应对加拿大移民系统。',
    },
    // [T243] ground truth 的收尾带(site/about.html §CTA BANNER):全站主门是免费评估
    // (design-hybrid §6),付费咨询是安静的第二道门;I29 只留一枚实心。
    cta: {
      title: '不确定从哪里开始？先做 10 分钟免费评估。',
      desc: '无需注册、无需付费——大约十分钟,把适合你情况的路径梳理出来。',
      action: '开始免费评估',
    },
  },

  // T28 — 问卷字段配置 admin panel. zh-primary; en gloss. Bilingual in both halves.
  admin: {
    fieldOverrides: {
      title: '问卷字段配置',
      intro: '选择每个申请类别需要询问的问题——可将任一问题设为必填、可选或隐藏。',
      floorNote: '正式表格要求的问题被锁定为表格的最低要求：只能收紧，不能放宽。',
      pathwayLabel: '申请类别',
      loading: '加载中…',
      noContract: '该申请类别暂无可配置的问卷。',
      state: {
        required: '必填',
        optional: '可选',
        hidden: '隐藏',
      },
      lockFormRequired: '{{forms}} 要求此项——不能设为可选或隐藏',
      lockFormConditional: '{{forms}} 在特定情况下需要此项——不能隐藏',
      lockBranch: '此项是其他问题的显示条件——不能隐藏',
      branchTag: '显示条件',
      updatedBy: '更新于',
      defaultTag: '默认',
      restoreDefault: '恢复默认',
      history: '更改记录',
    },
  }
};

export default translation;
